import { Product } from "@/types/types";

const APPLE_BRAND = "Apple";

// Selling product types that support the integrated "buy flow"
const BUY_FLOW_SELLING_PRODUCT_TYPES = [
  "Smartwatch",
  "Tablets",
  "Mobile Phones",
];

// Selling product types that support the standalone "sell flow"
const SELL_FLOW_SELLING_PRODUCT_TYPES = [
  "Laptops",
  "Smartwatch",
  "Tablets",
  "Mobile Phones",
  "Games Consoles",
  "Smart Rings",
  "Smart Glasses",
];

function isAppleLaptop(product: Product): boolean {
  return (
    product.sellingProductType === "Laptops" &&
    product.brand?.name === APPLE_BRAND
  );
}

export function isSellingProductTypeEligibleForBuyFlow(
  product: Product,
): boolean {
  if (isAppleLaptop(product)) {
    return true;
  }

  return (
    !!product.sellingProductType &&
    BUY_FLOW_SELLING_PRODUCT_TYPES.includes(product.sellingProductType)
  );
}

export function isSellingProductTypeEligibleForSellFlow(
  product: Product,
): boolean {
  return (
    !!product.sellingProductType &&
    SELL_FLOW_SELLING_PRODUCT_TYPES.includes(product.sellingProductType)
  );
}
